import Filter from "../Filter/Filter";
import Input from "../Input-new/Input";
import React from "react";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import '../Filter/Filter.scss';
import Dropdown from "../Dropdown/Dropdown";

export default class UserListFilter extends Filter {
    constructor(props) {
        super(props);
    }

    render() {
        const {query, paneIndex} = this.state;
        const isRequired = !query.first_name && !query.last_name;
        const panes = [
            (
                <React.Fragment>
                    <div className={`form-title dark`}>User</div>
                    {/* <Input theme='dark'
                           valueType='text'
                           name='name'
                           label='Name'
                           value={query.name}
                           required
                           handleParentChange={this.handleChange}
                    /> */}
                    {/* <Input 
                    theme='dark'
                       valueType='text'
                       name='first_name'
                       label='First Name'
                       value={query.first_name}
                       required={isRequired}
                       handleParentChange={this.handleChange}
                /> */}
                <Input 
                theme='dark'
                       valueType='text'
                       name='username'
                       label='User Name'
                       value={query.username}
                    //    required={isRequired}
                       handleParentChange={this.handleChange}
                />
                 <Input 
                theme='dark'
                       valueType='email'
                       name='email'
                       label='EMAIL'
                       value={query.email}
                    //    required={isRequired}
                       handleParentChange={this.handleChange}
                />
                  <Dropdown
                            className="Team-member-info_column_item"
                            theme='dark'
                            data={query}
                            optionKey='code'
                            optionLabelKey='name'
                            optionsType="type_code"
                            value={query.type_code}
                            valueKey="type_code"
                            label="User Type"
                            handleParentChange={this.handleDropdownChange}
                        />   
                         <Dropdown
                            className="Team-member-info_column_item"
                            theme='dark'
                            data={query}
                            optionKey='code'
                            optionLabelKey='name'
                            optionsType="user_type"
                            value={query.user_type}
                            valueKey="user_type"
                            label="Extended Properties (User Type)"
                            handleParentChange={this.handleDropdownChange}
                        />   
                          <Dropdown
                            className="Team-member-info_column_item"
                            theme='dark'
                            data={query}
                            optionKey='code'
                            optionLabelKey='name'
                            optionsType="status_code"
                            value={query.status_code}
                            valueKey="status_code"
                             label="Status"
                            handleParentChange={this.handleDropdownChange}
                        /> 
                          
                         {/* <Dropdown
                            className="Team-member-info_column_item"
                            theme='dark'
                            data={query}
                            optionKey='code'
                            optionLabelKey='name'
                            optionsType="status_code"
                            value={Array.isArray(query.status_code) ? query.status_code.join(",") : query.status_code || ""}
                            valueKey="type_code"
                            label="Status"
                            handleParentChange={this.handleDropdownChange}
                        />    */}
                </React.Fragment>
            ),
        ];

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {isSuper: this.props.isSuper})}
                </div>
                <SearchPanel ref='searchPanel'>
                    <nav className='Filter_nav'>
                        <div className='Filter_button' onClick={this.close}>Close</div>
                    </nav>

                    <form className='form' onSubmit={this.handleSubmit}>
                        <div className='form-slider'>
                            {
                                panes.map((el, key) => (
                                    <Control key={key} onClick={(key) => this.setState({paneIndex: key})}>
                                        <div className={`form-slider-icon dark${key === paneIndex ? ' active' : ''}`}/>
                                    </Control>
                                ))
                            }
                        </div>
                        {
                            panes[paneIndex]
                        }
                        <div className='filter-buttons'>
                            <button type='button' className='button-new negative dark' onClick={this.clear}>Clear</button>
                            <button className='button-new positive'>Apply</button>
                        </div>
                    </form>
                </SearchPanel>
            </div>
        );
    }
}